// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/_utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._5F1CuotDx{}._6Adhg432x{display:block;line-height:16px;padding-left:6px}._65IEjJYXx{}._5F1CuotDx ._65IEjJYXx{width:130px;padding:2px 6px;justify-content:space-between;font-weight:normal;font-size:14px;color:var(--primary-text)}._5F1CuotDx ._65IEjJYXx>svg path{fill:var(--primary-text)}._3eWBDSh5x{display:flex}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"filter-label": "_5F1CuotDx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bar-label-container"] + "",
	"filterLabel": "_5F1CuotDx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bar-label-container"] + "",
	"label": "_6Adhg432x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bar-label-label"] + "",
	"trigger": "_65IEjJYXx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bar-label-value"] + "",
	"select": "_3eWBDSh5x"
};
module.exports = exports;
